import { Theme } from '@mui/material';
import { Outcome } from '../../@types';
import { useEventCardOutcomeCell } from '../../hooks/useEventCardOutcomeCell';
import EventCardOutcomeCellBase from './EventCardOutcomeCellBase';

const makeStyles = (selected: boolean, disabled: boolean) => ({
  gridItem: (theme: Theme) => ({
    backgroundColor: selected ? 'neutral.100' : 'neutral.600',
    ':hover': {
      backgroundColor: !selected && !disabled ? 'neutral.400' : undefined,
    },
    '&:not(:last-child)': {
      borderRight: `1px solid ${theme.palette.neutral[700]}`,
    },
  }),
  container: {
    py: 1.5,
    px: 1.5,
    justifyContent: 'center',
    cursor: disabled ? 'not-allowed' : 'pointer',

    '& p': {
      typography: 'body2',
      fontSize: {
        md: 15,
      },
    },
    transition: 'all 150ms ease-in-out',
  },
  label: {
    color: selected ? 'neutral.600' : 'inherit',
  },
  odds: {
    typography: 'body2',
    ml: 1,
    fontWeight: 500,
    color: selected ? 'primary.main' : 'secondary.main',
  },
});

type EventCardOutcomeCellProps = {
  outcome: Outcome;
  onClick: () => void;
  outcomeCount: number;
};

const EventCardOutcomeCell = ({ outcome, ...rest }: EventCardOutcomeCellProps) => {
  const { selected, disabled } = useEventCardOutcomeCell(outcome);
  const styles = makeStyles(selected, disabled);

  return <EventCardOutcomeCellBase {...rest} outcome={outcome} styles={styles} disabled={disabled} />;
};

export default EventCardOutcomeCell;
